/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    // Remove 3-dot menu from custom-header
    const customHeader = document.querySelector('.gl-custom-header');
    if (customHeader) {
        const threeDotMenu = customHeader.querySelector('.gh-more-toggle');
        if (threeDotMenu) {
            threeDotMenu.remove();
        }
        customHeader.classList.add('is-dropdown-loaded');
    } else {
        dropdown();
    }
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();




/* Slide Hamburger Menu - Slides from Right */
(function () {
    const menuToggle = document.getElementById('slide-menu-toggle');
    const menuOverlay = document.getElementById('slide-menu-overlay');
    const menuContent = document.getElementById('slide-menu-content');
    const body = document.body;
    const html = document.documentElement;
    let scrollPosition = 0;

    if (!menuToggle || !menuOverlay || !menuContent) return;

    // Prevent scroll when menu is open
    function preventScroll(e) {
        e.preventDefault();
        window.scrollTo(0, scrollPosition);
    }

    function openMenu() {
        // Save scroll position
        scrollPosition = window.pageYOffset || html.scrollTop || body.scrollTop;
        
        // Prevent scrolling without position:fixed to avoid layout shift
        body.classList.add('slide-menu-open');
        html.classList.add('slide-menu-open');
        
        // Prevent scroll events
        window.addEventListener('scroll', preventScroll, { passive: false });
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });
        
        // Open menu smoothly
        requestAnimationFrame(function() {
            menuOverlay.classList.add('is-active');
            menuContent.classList.add('is-active');
        });
    }

    function closeMenu() {
        // Close menu first
        menuOverlay.classList.remove('is-active');
        menuContent.classList.remove('is-active');
        
        // Remove scroll prevention
        window.removeEventListener('scroll', preventScroll);
        window.removeEventListener('wheel', preventScroll);
        window.removeEventListener('touchmove', preventScroll);
        
        // Remove classes
        body.classList.remove('slide-menu-open');
        html.classList.remove('slide-menu-open');
        
        // Restore scroll position
        requestAnimationFrame(function() {
            window.scrollTo(0, scrollPosition);
        });
    }

    function toggleMenu() {
        if (menuContent.classList.contains('is-active')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    menuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu();
    });

    menuOverlay.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu();
    });

    // Close menu when clicking on header (but not on toggle button or menu content)
    const header = document.getElementById('gh-navigation');
    if (header) {
        header.addEventListener('click', function (e) {
            if (menuContent.classList.contains('is-active')) {
                // Don't close if clicking on toggle button or inside menu content
                if (!menuToggle.contains(e.target) && !menuContent.contains(e.target)) {
                    closeMenu();
                }
            }
        });
    }

    // Close menu on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menuContent.classList.contains('is-active')) {
            closeMenu();
        }
    });
})();